import React, { useState } from 'react';
import './CityRequestForm.css';

interface CityRequestFormProps {
  className?: string;
}

export const CityRequestForm: React.FC<CityRequestFormProps> = ({ className = '' }) => {
  const [city, setCity] = useState('');
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!city.trim()) {
      alert('Please enter a city name');
      return;
    }

    setLoading(true);

    try {
      // Send request to support email via mailto (simple approach)
      const subject = encodeURIComponent(`City Request: ${city}`);
      const body = encodeURIComponent(`City Requested: ${city}\n${email ? `Contact Email: ${email}` : 'No contact email provided'}`);
      const mailtoLink = `mailto:support@jollyio.com?subject=${subject}&body=${body}`;
      
      window.location.href = mailtoLink;
      
      // Show success message
      setSubmitted(true);
      setCity('');
      setEmail('');
      
      setTimeout(() => setSubmitted(false), 5000);
    } catch (error) {
      console.error('Error submitting city request:', error);
      alert('Something went wrong. Please email us directly at support@jollyio.com');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={`city-request-form ${className}`}>
      <div className="city-request-content">
        <h3>Don't see your city?</h3>
        <p>We're expanding! Request your city and we'll prioritize adding it.</p>
        
        {submitted ? (
          <div className="success-message">
            ✓ Thank you! Your request has been submitted.
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <div className="form-row">
              <input
                type="text"
                placeholder="City name"
                value={city}
                onChange={(e) => setCity(e.target.value)}
                required
                disabled={loading}
              />
              <input
                type="email"
                placeholder="Your email (optional)"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                disabled={loading}
              />
              <button type="submit" disabled={loading}>
                {loading ? 'Submitting...' : 'Request City'}
              </button>
            </div>
          </form>
        )}
        
        <p className="privacy-note">
          Currently serving: Houston and The Woodlands
        </p>
      </div>
    </div>
  );
};
